module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"click_to_select":"Click to select","click_to_edit":"Click to edit","row_answer_required":"Each row must have one response."},"zh":{"click_to_select":"點此選擇","click_to_edit":"點此編輯","row_answer_required":"每列須有一則回應"}}')
  delete Component.options._Ctor
}
